/**
 * Service for handling authentication token persistence.
 * Standardizes 'auth_token' as the single canonical key for token storage.
 */
const TOKEN_KEY = "auth_token";
const ROLE_KEY = "user_role";

const LEGACY_TOKEN_KEY = "authToken";
const LEGACY_USER_INFO_KEY = "userInformation";

export const storageService = {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
  },

  getRole(): string | null {
    return localStorage.getItem(ROLE_KEY);
  },

  setRole(role: string): void {
    localStorage.setItem(ROLE_KEY, role);
  },

  clearAuth(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ROLE_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.removeItem(LEGACY_USER_INFO_KEY);
  },
};


